const getters = {
    sourceType: state => state.user.sourceType,
    organization: state => state.user.organization
}

export default getters
